import React, {useEffect, useState} from 'react';
import InfoPage from './info/InfoPage';
import '../styles/header.scss';
import {MdKeyboardArrowDown} from 'react-icons/md';
import {Link} from 'react-router-dom';
import NotificationPage from './notification/NotificationPage';
import {ProfileMenu} from './ProfileMenu';

const HeaderUser = () => {
  const [isInfo, setIsInfo] = useState(false);
  const [isNotification, setIsNotification] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setIsNotification(true);
    }, 1000);
  }, []);

  return (
    <div className="header_user_wrap">
      <Link to="/">
        <div className="logo_wraper">
          <img src="/img/Logo.svg" alt="Logo" />
        </div>
      </Link>
      <div className="profile_menu_wraper">
        <img
          src="/img/header/Information.svg"
          alt="Information.svg"
          onClick={() => setIsInfo((state) => !state)}
        />
        <Link to="/notification">
          <div className="notifications_wrap">
            <img src="/img/header/Notifications.svg" alt="Notifications.svg" />
            <div className="notifications_triger"></div>
          </div>
        </Link>

        {/* <div className="profile_icon">
          <div className="img_hero_wrap">
            <img src="/img/header/Plug.svg" alt="Plug.svg" />
          </div>
          <div className="profile_dropdown">
            <MdKeyboardArrowDown />
          </div>
        </div> */}
        <ProfileMenu />
      </div>
      {isInfo && <InfoPage setIsInfo={setIsInfo} />}
    </div>
  );
};

export default HeaderUser;
